/**
 * Default Google Maps API key (mirrors mobile)
 */
const DEFAULT_GOOGLE_MAPS_API_KEY = 'AIzaSyAZI9pmamUZv6OApgFlmz9Z3eDenFUy_Bo'

/**
 * Gets Google Maps API key
 * @returns Google Maps API key
 */
export function getGoogleMapsApiKey(): string {
  return process.env.REACT_APP_GOOGLE_MAPS_API_KEY || DEFAULT_GOOGLE_MAPS_API_KEY
}

/**
 * Gets Google Maps Map ID
 * @returns Google Maps Map ID
 */
export function getGoogleMapsMapId(): string {
  return process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || '360d5a790062a99f2c83b605'
}
